import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';

interface IPagePb0006 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
}
/* @ngInject */
export default function Pb0006Controller(Formulaire: IFormulaireClass,
    Menu: IMenuClass,
    $stateParams: any) {

    const vm: IPagePb0006 = this;

    vm.multiOccurrenceOptions = {
        filtresParametres: [
            { colonne: 'pvecleint', valeur: $stateParams.pvecleint, visible: false }
        ],
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            { nom: 'prucod', largeur: 90 },
            { nom: 'prudscl01', largeur: 200 },
            { nom: 'prscod', largeur: 90 },
            { nom: 'prsdscl01', largeur: 140 },
            { nom: 'cifcod', largeur: 90 },
            { nom: 'cifdscabr', largeur: 140 },
            { nom: 'unacod', largeur: 90 },
            { nom: 'unadscabr', largeur: 150 },
            { nom: 'el1cod', largeur: 90 },
            { nom: 'el1dscabr', largeur: 120 },
            { nom: 'grecod', largeur: 90 },
            { nom: 'gredsc', largeur: 120 },
            { nom: 'temcod', largeur: 90 },
            { nom: 'temdscabr', largeur: 240 },
            { nom: 'posnumdoc', largeur: 90 },
            { nom: 'postitabr', largeur: 240 },
            { nom: 'eplnummat', largeur: 90 },
            { nom: 'eplnomprn', largeur: 120 },
            { nom: 'eplnomprnusu', largeur: 130 },
            { nom: 'pvenumver', largeur: 120 },
            { nom: 'pveann', largeur: 90 },
            { nom: 'peccod', largeur: 90 },
            { nom: 'intcod', largeur: 120 },
            { nom: 'intnom', largeur: 150 },
            { nom: 'pbscod', largeur: 90 },
            { nom: 'pbsdsc', largeur: 120 },
            { nom: 'mntsalpre', largeur: 120 },
            { nom: 'mntsalree', largeur: 120 },
            { nom: 'mntsalpro', largeur: 100 },
            { nom: 'mntavspre', largeur: 120 },
            { nom: 'mntavsree', largeur: 120 },
            { nom: 'mntavspro', largeur: 120 }
        ]
    };
}
